import { AxiosResponse } from 'axios';
import { SET_MILESTONES, SET_MILESTONE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_MILESTONE_ISLOADING,
  DELETE_MILESTONE,
  EDIT_MILESTONE,
  GET_MILESTONES,
  GET_MILESTONE,
  REGISTER_MILESTONE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Milestone from '@/services/milestone';
import { Module } from 'vuex';
import { EditMilestone, RegisterMilestone, GetMilestone } from '@/dtos/milestone.dto';

const milestone: Module<any, {}> = {
  state: {
    milestone: {
      data: null,
      isLoading: false,
    },
    milestones: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    milestone: (state: { milestone: any }) => state.milestone,
    milestones: (state: { milestones: any }) => state.milestones,
  },
  mutations: {
    [SET_MILESTONE]: (
      state: { milestone: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.milestone.data = payload.data) : null,
        (state.milestone.isLoading = payload.isLoading);
    },
    [SET_MILESTONES]: (
      state: { milestones: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.milestones.data = payload.data) : null,
        (state.milestones.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_MILESTONE]: async ({ commit }: any, payload: any) => {
      commit(SET_MILESTONE, { data: null, isLoading: true });

      const result: AxiosResponse = await Milestone.registerMilestone(
        payload as RegisterMilestone
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MILESTONE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MILESTONE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MILESTONE, { isLoading: false });
        return false;
      }
    },
    [GET_MILESTONES]: async ({ commit }: any, payload: any) => {
      commit(SET_MILESTONES, { data: null, isLoading: true });

      const result: AxiosResponse = await Milestone.getMilestones(
        payload as GetMilestone
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MILESTONES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MILESTONES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MILESTONES, { isLoading: false });
        return false;
      }
    },
    [GET_MILESTONE]: async ({ commit }: any, payload: any) => {
      commit(SET_MILESTONE, { data: null, isLoading: true });

      const result: AxiosResponse = await Milestone.getMilestones(
        payload as GetMilestone
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MILESTONE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_MILESTONE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MILESTONE, { isLoading: false });
        return false;
      }
    },
    [EDIT_MILESTONE]: async ({ commit }: any, payload: any) => {
      commit(SET_MILESTONE, { data: null, isLoading: true });

      const result: AxiosResponse = await Milestone.editMilestone(
        payload as EditMilestone
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MILESTONE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MILESTONE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MILESTONE, { isLoading: false });
        return false;
      }
    },
    [DELETE_MILESTONE]: async ({ commit }: any, payload: string) => {
      commit(SET_MILESTONE, { data: null, isLoading: true });

      const result: AxiosResponse = await Milestone.deleteMilestone(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MILESTONE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MILESTONE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MILESTONE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_MILESTONE_ISLOADING]: ({ commit }) => {
      commit(SET_MILESTONE, { isLoading: false });
      commit(SET_MILESTONES, { isLoading: false });
    },
  },
};

export default milestone;

